module.exports = __webpack_public_path__ + "static/media/FOUR.8f1df38f.png";